/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Leave_Open_TextInputs */



/**
* | output |
* | --- |
* | "Please leave this window open until rendering completes" |
*
* @param {Render_Audio_Leave_Open_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_leave_open_text = /** @type {((inputs?: Render_Audio_Leave_Open_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Leave_Open_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez laisser cette fenetre ouverte jusqu'a la fin du rendu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte lassen Sie dieses Fenster geöffnet, bis der Rendering-Vorgang abgeschlossen ist.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si prega di lasciare aperta questa finestra fino al completamento del rendering")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, оставьте это окно открытым до завершения рендеринга.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deje esta ventana abierta hasta que se complete la renderización.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请保持此窗口打开，直到渲染完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レンダリングが完了するまでこのウィンドウを開いたままにしてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया रेंडरिंग पूरी होने तक इस विंडो को खुला रखें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, deixe esta janela aberta até que a renderização seja concluída.")
	return /** @type {LocalizedString} */ ("Please leave this window open until rendering completes")
});